import $ from 'jquery';

$(window).scroll(function() {
    var $header = $('.header');
    if($(window).width() >= 1280) {
        if($(window).scrollTop() > 300) {

            $header.addClass('header--fixed');
            if($(window).scrollTop() > 500) {
                $header.addClass('header--scroll');
            }
            else {
                $header.removeClass('header--scroll');
            }
        }
        else {
            $header.removeClass('header--fixed');
            $header.removeClass('header--scroll');
        }
    }
});
